import { api_request } from '../../Services/helpers'

export const getDashboardStats = async () =>
  await api_request('get', '/auth/dashboard/stats', {}, true)

export const markNotificationRead = async (id) =>
  await api_request('get', `/auth/dashboard/read_notification/${id}`, {}, true)
